import React from "react";
import "../../Styles/certified/mnc.css";

export default function MNCCorporateSystem() {
  return (
    <>
      <div className="mnc-certified-details-section">
        <div className="mnc-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="mnc-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="mnc-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="mnc-certified-badge"
            />
            <div className="mnc-certified-company-names">
              <a href="https://www.mncindiafilings.com" target="_blank" rel="noopener noreferrer">
                <img src="/assets/mnc/mnclogo.png" alt="MNC Corporate Logo" className="mnc-certified-company-logo" />
              </a>
              <h1 className="mnc-certified-full-name">
                MNC Corporate System India Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="mnc-certified-details-right">
            <img
              src="/assets/mnc/1.jpeg"
              alt="MNC Corporate Office"
              className="mnc-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="mnc-certified-description">
          <h2>
            Why MNC Corporate System India Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            The Company is a professionally managed organisation engaged in providing business support in auditing and professional services. 
            It operates in compliance with applicable laws and regulatory requirements and follows robust internal controls and governance practices. 
            The Company caters to domestic and multinational clients and focuses on delivering quality-driven, timely, and reliable services. 
            With a qualified management team and experienced professionals, the organisation is committed to ethical business conduct, operational excellence, and sustainable growth.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="mnc-certified-info-cards">
          <div className="mnc-certified-info-card">
            <div className="mnc-certified-info-title">COMPANY SIZE</div>
            <div className="mnc-certified-info-value">35 Employees</div>
          </div>
          <div className="mnc-certified-info-card">
            <div className="mnc-certified-info-title">INDUSTRY</div>
            <div className="mnc-certified-info-value">Accouting & Business Consultant</div>
          </div>
          <div className="mnc-certified-info-card">
            <div className="mnc-certified-info-title">CONNECT</div>
            <div className="mnc-certified-info-icons">
              <span className="mnc-certified-icon-round">
                <a href="https://www.mncindiafilings.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="mnc-certified-icon-round">
                <a href="https://www.linkedin.com/in/mnc-groups-682438181" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="mnc-certified-icon-round">
                <a href="https://www.facebook.com/mnccorporate" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="mnc-certified-icon-round">
                <a href="https://www.instagram.com/mnccorporatesystem" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
              <span className="mnc-certified-icon-round">
                <a href="https://twitter.com/MNC_Groups" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="mnc-certified-info-card">
            <div className="mnc-certified-info-title">LOCATION (HQ)</div>
            <div className="mnc-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="mnc-certified-recognition-section">
          <h2 className="mnc-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="mnc-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="mnc-certified-recognition-image"
            />
          </div>
          <div className="mnc-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at MNC Corporate Section */}
        <div className="mnc-certified-life-section">
          <h2 className="mnc-certified-life-title">
            Life at MNC Corporate System India Private Limited
          </h2>
          <div className="mnc-certified-life-gallery">
            <div className="mnc-certified-life-col">
              <img src="/assets/mnc/2.jpeg" alt="Office 2" className="mnc-certified-life-img" />
              <img src="/assets/mnc/3.jpeg" alt="Team" className="mnc-certified-life-img" />
            </div>
            <div className="mnc-certified-life-col mnc-certified-life-center">
              <img src="/assets/mnc/5.jpeg" alt="Main Office" className="mnc-certified-life-img mnc-certified-life-img-large" />
            </div>
            <div className="mnc-certified-life-col">
              <img src="/assets/mnc/4.jpeg" alt="Office 4" className="mnc-certified-life-img" />
              <img src="/assets/mnc/6.jpeg" alt="Meeting" className="mnc-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}